import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logonew from "../../assets/images/logo.png";

function Main() {
    const [active, setActive] = useState();
    const [show, setShow] = useState();
    const [menu, setMenu] = useState();
    const [page, setPage] = useState();
    const [drop, setDrop] = useState();
    const [lastscrool, setlastscrool] = useState(0);

    const [scrolled, setScrolled] = useState(false);
    const [Nav, setNav] = useState(true);

    const handleScroll = () => {
        const offset = window.scrollY;
        setlastscrool(offset);

        if (offset > 1000 && offset < lastscrool) {
            setNav(true);
            setScrolled(true);
        } else if (offset > 1000) {
            setNav(false);
        } else if (offset > 200) {
            setNav(true);
            setScrolled(true);
        } else {
            setScrolled(false);
            setNav(true);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
    });

    return (
        <>
            {active && (
                <div
                    className="menu-backdrop"
                    style={{ opacity: "1", visibility: "visible" }}
                ></div>
            )}
            <section className={`hidden-bar ${active && "visible-sidebar"}`}>
                <div className="inner-box">
                    <div
                        className="cross-icon hidden-bar-closer"
                        onClick={() => setActive(false)}
                    >
                        <span
                            className="far fa-close"
                            onClick={() => setActive(false)}
                        >
                            {" "}
                        </span>
                    </div>
                    <div className="logo-box">
                        <Link to="/" title="Chez François Restaurant">
                            <img
                                src={logonew}
                                alt=""
                                title="Chez François Restaurant"
                            />
                        </Link>
                    </div>

                    <div className="side-menu">
                        <ul className="navigation clearfix">
                            <li>
                                <Link to="/" onClick={() => setActive(false)}>
                                    Home
                                </Link>
                            </li>
                            <li className="dropdown">
                                <Link
                                    to="#"
                                    onClick={() =>
                                        setMenu(menu === true ? false : true)
                                    }
                                >
                                    Menus
                                    <button
                                        type="button"
                                        className="btn-expander"
                                    >
                                        <i className="far fa-angle-down"></i>
                                    </button>
                                </Link>
                                <ul
                                    style={{ display: menu ? "block" : "none" }}
                                >
                                    <li>
                                        <Link
                                            to="/menubreakfast"
                                            onClick={() => setActive(false)}
                                        >
                                            Breakfast
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/menulunch"
                                            onClick={() => setActive(false)}
                                        >
                                            Lunch
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <Link
                                    to="/services"
                                    onClick={() => setActive(false)}
                                >
                                    Services
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/about"
                                    onClick={() => setActive(false)}
                                >
                                    About Us
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/contact"
                                    onClick={() => setActive(false)}
                                >
                                    {" "}
                                    Contact{" "}
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/careers"
                                    onClick={() => setActive(false)}
                                >
                                    Join Our Team
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="https://app.tableup.com/r/1901/home"
                                    onClick={() => setActive(false)}
                                >
                                    {" "}
                                    Order Online{" "}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* <h2>Visit Us</h2> */}
                    <ul className="info">
                        <li>
                            1716 BOW VALLEY TRAIL, <br /> CHATEAU CANMORE
                            QUALITY RESORT,
                            <br /> CANMORE T1W 2X3{" "}
                        </li>
                        <li>Monday to Friday: 7 AM TO 2:30 PM</li>
                        <li>Saturday, Sunday: 7 AM TO 3:00 PM</li>
                        {/* <li><Link to="mailto:booking@domainame.com">booking@domainame.com</Link></li> */}
                    </ul>
                    <div className="booking-info">
                        {/* <div className="bk-title">Call us</div> */}
                        {/* <div className="bk-no">
                            <Link to="tel:+1-403-678-6111">
                                +1 403 678 6111
                            </Link>
                        </div> */}
                    </div>
                </div>
            </section>
            {Nav && (
                <header
                    className={`main-header ${
                        scrolled && "fixed-header"
                    } header-down`}
                >
                    <div className="header-top">
                        <div className="auto-container">
                            <div className="inner clearfix">
                                <div className="top-left clearfix">
                                    <ul className="top-info clearfix">
                                        <li>
                                            <i className="icon far fa-map-marker-alt"></i>{" "}
                                            1716 Bow Valley Trail, Canmore, CA
                                        </li>
                                        <li>
                                            <i className="icon far fa-clock"></i>{" "}
                                            Daily : 7.00 am to 2.30 pm (3:00 pm
                                            Weekends)
                                        </li>
                                    </ul>
                                </div>
                                <div className="top-right clearfix">
                                    <ul className="top-info clearfix">
                                        <li>
                                            <Link to="tel:+1-403-678-6111">
                                                <i className="icon far fa-phone"></i>{" "}
                                                +1 403 678 6111{" "}
                                            </Link>{" "}
                                        </li>
                                        {/* <li><Link to="mailto:booking@restaurant.com"><i className="icon far fa-envelope"></i> booking@restaurant.com</Link></li> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="header-upper header-fixed">
                        <div className="auto-container">
                            <div className="main-box d-flex justify-content-between align-items-center flex-wrap">
                                <div className="links-box clearfix">
                                    <div className="nav-toggler">
                                        <button className="hidden-bar-opener">
                                            <span
                                                className="hamburger"
                                                onClick={() => setActive(true)}
                                            >
                                                <span className="top-bun"></span>
                                                <span className="meat"></span>
                                                <span className="bottom-bun"></span>
                                            </span>
                                        </button>
                                    </div>
                                </div>

                                {scrolled && (
                                    <div className="logo-box">
                                        <div className="logo">
                                            <Link to="/" title="Logo here">
                                                <img
                                                    src={logonew}
                                                    alt=""
                                                    title="Chez François Restaurant"
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                )}

                                <div className="parent-container">
                                    <div className="link link-btn" style={{ margin: "15px" }}>
                                        <Link
                                            to="https://app.tableup.com/r/1901/home"
                                            className="theme-btn btn-style-one clearfix"
                                        >
                                            <span className="btn-wrap">
                                                <span className="text-one">
                                                    order online
                                                </span>
                                                <span className="text-two">
                                                    order online
                                                </span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            )}
        </>
    );
}

export default Main;
